import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { Button } from "react-bootstrap";
import "react-loading-skeleton/dist/skeleton.css";
import AdminSidebar from "../../layouts/AdminSidebar";
import { Trash, Plus, PencilSquare } from "react-bootstrap-icons";
import { authCall } from "../../../services";
import ScavengerHungLocationAddPopup from "./ScavengerHungLocationAddPopup";

function ScavengerHuntLocaions() {
  const today = moment().format("YYYY-MM-DD");
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [itemDetails, setItemDetails] = useState(null);

  const initialField = [
    {
      date: today,
      company: "All Companies",
      companyName: "",
      address: "",
      zipCode: "",
      city: "",
      state: "",
      latitude: "",
      longitude: "",
      startTime: "",
      endTime: "",
      activeDays: {
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false,
        Sun: false,
      },
      locationType: "",
      offer: "",
      offerPhoto: "",
      photoSpot: "",
      adult: true,
      iconType: "",
      subscriptionLevel: "",
      subscribeButton: "",
      isItemPhotoUploaded: false,
      new: true,
      keyFacts: "",
    },
  ];

  const [items, setItems] = useState(initialField);

  const getItemsDetails = async () => {
    setLoading(true);
    const resp = await authCall("getScavengerHuntLocaions", {});
    if (resp?.type === "success") {
      setItems(resp?.payload);
      setLoading(false);
    }
  };

  useEffect(() => {
    getItemsDetails();
  }, []);

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
          disabled={loadingDelete || false}
        >
          {loadingDelete ? "Loading..." : "Yes"}
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    if (el?.id) {
      const resp = await authCall("deleteScavengerHuntLocaions", {
        id: el.id,
        isSoft: true,
      });
      setLoadingDelete(true);
      if (resp?.type === "success") {
        closeToast();
        toast.success(resp?.message);
        setLoadingDelete(false);
        getItemsDetails();
      } else {
        toast.error(resp?.message);
        setLoadingDelete(false);
      }
    } else {
      setItems(items.filter((e) => e.id !== el.id));
      closeToast();
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const closeModal = () => {
    setModalStatus(false);
  };

  const handleEdit = (el) => {
    setItemDetails(el);
    setModalStatus(true);
  };
  return (
    <>
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Scavenger Hunt Locations</div>

                <div className="details-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div
                          className="main-heading2 mb-3 mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Scavenger Hunt Locations:
                          {loading && (
                            <Skeleton count={1} height={31} width={120} />
                          )}
                          {!loading && (
                            <Button
                              className="btn btn-custom btn-custom-sm fs-16"
                              onClick={() => setModalStatus(true)}
                            >
                              <Plus />
                              Add Another Locations
                            </Button>
                          )}
                        </div>
                        {loading && (
                          <div className="text-center mt-3">
                            Loading... Please wait
                          </div>
                        )}
                        {!loading &&
                          items.map((field, index) => (
                            <div key={index}>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Location Type
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.location_type}
                                  />
                                </div>
                                <div className="col-3">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Company
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.company}
                                  />
                                </div>
                                {field?.company === "Other" && (
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Enter Company Name
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field.company_name}
                                    />
                                  </div>
                                )}

                                <div className="col-3">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Address
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.address}
                                  />
                                </div>
                                {field?.company !== "Other" && (
                                  <>
                                    <div className="col-2">
                                      <label
                                        htmlFor="RestaurantPhone"
                                        className="fs-md-16 mb-2 text-custom-primary"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Latitude
                                      </label>
                                      <input
                                        readOnly
                                        type="text"
                                        className="form-control"
                                        value={field?.latitude}
                                      />
                                    </div>
                                    <div className="col-2">
                                      <label
                                        htmlFor="RestaurantPhone"
                                        className="fs-md-16 mb-2 text-custom-primary"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Longitude
                                      </label>
                                      <input
                                        readOnly
                                        type="text"
                                        className="form-control"
                                        value={field?.longitude}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                              {/* address */}
                              {field?.company === "Other" && (
                                <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      City
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field?.city}
                                    />
                                  </div>
                                  <div className="col-2">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      State
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field?.state}
                                    />
                                  </div>
                                  <div className="col-2">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Zip Code
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field?.zipCode}
                                    />
                                  </div>

                                  <div className="col-2">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Latitude
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field?.latitude}
                                    />
                                  </div>
                                  <div className="col-2">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Longitude
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field?.longitude}
                                    />
                                  </div>
                                </div>
                              )}

                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-8">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Active Days
                                  </label>
                                  <div className="form-group d-flex align-items-center gap-4 flex-wrap">
                                    {Object.entries(
                                      field?.active_days || {}
                                    ).map(([day, isActive], index) => (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        <input
                                          disabled
                                          type="checkbox"
                                          className="mt-2"
                                          checked={isActive}
                                        />
                                        <label
                                          className="m-0 fs-md-16 text-custom-primary"
                                          htmlFor={`day_${index}`}
                                        >
                                          {day}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Start Time
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.start_time}
                                  />
                                </div>
                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    End Time
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.end_time}
                                  />
                                </div>
                              </div>

                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-5 d-flex align-items-center">
                                  <div className="d-flex align-items-center gap-2 m-0">
                                    <input
                                      disabled
                                      type="checkbox"
                                      name="photoSpot"
                                      checked={
                                        field?.photo_spot === "1" || false
                                      }
                                    />
                                    <label
                                      className="form-check-label fs-md-16 text-custom-primary"
                                      htmlFor="photoSpot"
                                    >
                                      Photo Spot
                                    </label>
                                  </div>

                                  <div className="form-check d-flex align-items-center gap-2 m-0">
                                    <input
                                      disabled
                                      type="checkbox"
                                      checked={field?.adult === "1" || false}
                                    />
                                    <label
                                      className="form-check-label fs-md-16 text-custom-primary"
                                      htmlFor="adult"
                                    >
                                      Adult
                                    </label>
                                  </div>

                                  <div className="form-check d-flex align-items-center gap-2 m-0">
                                    <input
                                      disabled
                                      type="checkbox"
                                      checked={field?.is_radio === "1" || false}
                                    />
                                    <label
                                      className="form-check-label fs-md-16 text-custom-primary"
                                      htmlFor="radio"
                                    >
                                      Radio
                                    </label>
                                  </div>
                                </div>

                                {/* RADIO PRIZE */}
                                {field?.is_radio === "1" && (
                                  <div className="col-3">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Radio Prize
                                    </label>
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      value={field?.radio_prize}
                                    />
                                  </div>
                                )}

                                <div
                                  className={`${
                                    field?.is_radio === "1" ? "col-2" : "col-3"
                                  }`}
                                >
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Icon Type
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.icon_type}
                                  />
                                </div>

                                <div
                                  className={`${
                                    field?.is_radio === "1" ? "col-2" : "col-4"
                                  }`}
                                >
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700, zIndex: 0 }}
                                  >
                                    Subscription Level
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.subscription_level}
                                  />
                                </div>
                              </div>

                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                {/* KEY FACTORS */}
                                <div className="col-5">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-1 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Key Facts
                                  </label>
                                  <textarea
                                    readOnly
                                    rows={3}
                                    className="form-control"
                                    value={field?.key_facts}
                                  />
                                </div>

                                {/* OFFER */}
                                <div className="col-3">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Offer
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control"
                                    value={field?.offer}
                                  />
                                </div>

                                {/* OFFER PHOTO */}
                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Offer Photo
                                  </label>
                                  <div
                                    style={{ width: "120px" }}
                                    className="img-wrapper"
                                  >
                                    <img
                                      src={field?.offer_photo}
                                      className="img-fluid rounded"
                                      alt="cropped"
                                    />
                                  </div>
                                </div>

                                {/* QR CODE */}
                                <div className="col-2">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    QR Code
                                  </label>
                                  <div
                                    style={{ width: "120px" }}
                                    className="img-wrapper"
                                  >
                                    <img
                                      src={field?.qr_image}
                                      className="img-fluid rounded"
                                      alt="cropped"
                                    />
                                    <div className="text-center"><a href={field?.qr_image} target="_blank">Download</a></div>
                                  </div>
                                </div>
                              </div>
                              <div className="row gx-3 d-flex flex-wrap align-items-center">
                                <div className="col-12 text-center">
                                  <PencilSquare
                                    onClick={() => handleEdit(field)}
                                    className="cursor-pointer"
                                    title="Click to edit"
                                    style={{
                                      width: 25,
                                      height: 25,
                                      color: "#ddb12e",
                                    }}
                                  />
                                  {items.length > 1 && (
                                    <Trash
                                      onClick={() => handleDelete(field)}
                                      className="cursor-pointer"
                                      title="Click to delete"
                                      style={{
                                        marginLeft: 20,
                                        color: "red",
                                        width: 25,
                                        height: 25,
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                        {items.length === 0 && (
                          <div className="text-center mt-3">
                            No deals available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScavengerHungLocationAddPopup
        modalStatus={modalStatus}
        closeModal={closeModal}
        itemDetails={itemDetails}
      />
    </>
  );
}

export default ScavengerHuntLocaions;
